import { useCallback, useMemo } from 'react'

import { useGetTrackedGameQuery } from '../../../api/core'
import { useGetAvailableAISummariesForGamesQuery } from '../../../api/live-event-predictions'
import { useCurrentUserLanguage } from '../../account/hooks/useCurrentUserLanguage'
import { TrackedGame } from '../types/TrackedGame'

type UseTrackedGameHookParams = {
  gameId: string
  skip?: boolean
}

export const useTrackedGame = ({ gameId, skip }: UseTrackedGameHookParams) => {
  const userLanguage = useCurrentUserLanguage()
  const aiSummariesForGames = useGetAvailableAISummariesForGamesQuery()
  const trackedGame = useGetTrackedGameQuery({ gameId, userLanguage }, { skip })

  const enrichWithAISummaries = useCallback(
    (gameData: TrackedGame | undefined) => {
      if (!gameData || !aiSummariesForGames.data) return undefined
      const aiSummaryForGame = aiSummariesForGames.data.find((summary) => summary.gameId === gameData.game.id)
      return { ...gameData, aiSummariesAvailable: aiSummaryForGame ? aiSummaryForGame.prompts : [] }
    },
    [aiSummariesForGames.data]
  )

  const data = useMemo(() => enrichWithAISummaries(trackedGame.data), [enrichWithAISummaries, trackedGame.data])

  return {
    data,
    isLoading: trackedGame.isLoading,
    isFetching: trackedGame.isFetching,
    error: trackedGame.error,
    isError: trackedGame.isError,
  }
}
